export const FILE_SIZE_SMALL_LIMIT_MB = 5;
export const FILE_SIZE_LARGE_LIMIT_MB = 10;
